import { chain } from 'underscore';

export const processErrors = (errors, filter) => {
  let process = chain(errors);
  if (filter) {
    process = process.filter(filter);
  }
  return process.value();
};

const lastResortErrorMapper = error => error.toString();
export const processErrorMessages = (errors, mapper) => {
  let process = chain(errors);
  if (mapper) {
    process = process.map(mapper);
  } else {
    process = process.map(lastResortErrorMapper);
  }
  return process.uniq().value();
};
